import { Box, Button } from "src/components/MuiGenerals";
import { useBatchContractSweepPreviewContext } from "../../contexts";
import { customSx } from "src/utils/styling";
import Summary from "./components/Summary";
import Table from "./components/Table";
import { useAlerting, usePermission } from "src/hooks";
import { useEffect } from "react";
import { FeatureCode } from "@wallet-manager/node-types";

function Preview() {
  const {
    previewData,
    onSubmit,
    onReset,
    translate: t,
  } = useBatchContractSweepPreviewContext();
  const { alerting } = useAlerting();
  const { hasPermission } = usePermission();

  useEffect(() => {
    if (!previewData || previewData.addressData.length) {
      return;
    }

    alerting("warning", t("no_data_to_preview"));
  }, [previewData]);

  if (!previewData || !previewData.addressData.length) {
    return null;
  }

  return (
    <Box
      sx={{
        ...customSx.layoutBox,
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}>
      <Summary />
      <Table />
      <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
        {hasPermission(
          FeatureCode.FeaturesAssetManagement.BatchContractSweep.Submit,
        ) && (
          <Button
            onClick={onSubmit}
            // sx={sx.preview}
            color="secondary"
            variant="contained">
            {t("submit")}
          </Button>
        )}
        <Button
          onClick={onReset}
          // sx={sx.preview}
          color="info"
          variant="contained">
          {t("reset")}
        </Button>
      </div>
    </Box>
  );
}

export default Preview;
